export default {
  methods: {
    showEventLocationOnMap (event) {
      const { location } = event?.rowData || {}
      const latitude = location?.lat
      const longitude = location?.lng

      if (!latitude || !longitude) {
        return
      }

      this.$set(this.chooseLocationDialogConfig, 'markers', {
        lat: latitude,
        lng: longitude
      })
      this.$set(this.chooseLocationDialogConfig, 'title', this.$t('base.location_preview'))
      this.$set(this.chooseLocationDialogConfig, 'createMode', false)
      this.$set(this.chooseLocationDialogConfig, 'show', true)
    }
  }
}
